import { NgModule } from '@angular/core';
import { JotformComponent } from './jotform.component';

@NgModule({
  declarations: [JotformComponent],
  exports: [JotformComponent],
})
export class JotformModule {}
